import Cookies from 'js-cookie';
import moment from 'moment-timezone';
import { useCallback, useEffect, useState } from 'react';

import { DEFAULT_IANA_TIME_ZONE } from '../constants';
import { AuthContext } from '../context';

export const AuthProvider = ({ children }) => {
  const [userRole, setUserRole] = useState(null);
  const [isUserRoleLoading, setIsUserRoleLoading] = useState(true);
  const [recordingVisible, setRecordingVisible] = useState(true);

  const fetchDB = useCallback(async () => {
    setIsUserRoleLoading(true);

    try {
      const response = await fetch('/db', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username: '', password: '' }),
      });

      if (response.status !== 200) throw new Error();

      const ianaTimeZone = Cookies.get('ianaTimeZone');
      moment.tz.setDefault(ianaTimeZone ?? DEFAULT_IANA_TIME_ZONE);
      const role = Cookies.get('role');
      setUserRole(role);
      setRecordingVisible(Cookies.get('recordingVisible') === 'true');
      setIsUserRoleLoading(false);
    } catch {
      setUserRole(null);
      setIsUserRoleLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchDB();
  }, [fetchDB]);

  const hasUserRole = userRole !== null;

  return (
    <AuthContext.Provider
      value={{
        isUserRoleLoading,
        hasUserRole,
        userRole,
        setUserRole,
        recordingVisible,
        setRecordingVisible,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
